<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <h3 v-if="showTitle" class="mb-5">Prašymai dėl juridinių faktų</h3>

    <v-data-table
      :loading="loading"
      :headers="headers"
      :items="filterItemList"
      :item-class="rowClass"
      :search="search"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
    >
      <template #top>
        <v-toolbar flat
          ><v-text-field
            v-model="search"
            prepend-icon="mdi-magnify"
            label=""
            single-line
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template #[`item.salys`]="{ item }">
        <v-row dense no-gutters>
          <v-col cols="12" md="12">
            <v-row dense no-gutters>
              <v-col cols="12" md="12" v-for="salis in item.salys" :key="salis">
                {{ salis }}
              </v-col>
              <v-col cols="12" md="12" v-if="item.salysCut">
                ...
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </template>
      <template #[`item.pra_busena_pavadinimas`]="{ item }">
        <el-prasymas-busena :busena="item.pra_busena_pavadinimas" />
      </template>
      <template #[`item.atnaujinimo_data`]="{ item }">
        <div class="nowrap">{{ item.atnaujinimo_diena }}</div>
        <div class="nowrap">{{ item.atnaujinimo_laikas }}</div>
      </template>
      <template #[`item.actions`]="{ item }">
        <el-table-action
          :item="item"
          @editItem="editItem(item)"
          @viewItem="editItem(item)"
          @deleteItem="deleteItem(item)"
          @restoreItem="restoreItem(item)"
          @duplicateItem="duplicateItem(item)"
          @transferItem="transferItem(item)"
        />
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        Duomenų nėra
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <div class="mt-4 mb-2">
      Rengiami, neperduoti registrui dokumentai bus pašalinti iš sistemos
      praėjus {{ salinimoLaikas }} k.d. nuo paskutinės pakeitimo datos.
    </div>
    <v-footer class="form-footer">
      <v-spacer></v-spacer>
      <el-button
        primary
        @click.native="
          printData('ntrpaslaugos/rengiami/print', 'Rengiami prasymai')
        "
        :disabled="canPrint"
        :loading="loading"
        >Spausdinti</el-button
      >
    </v-footer>

    <modal-delete
      title="Šalinti dokumentą?"
      :text="
        `Ar norite pašalinti rengiamą dokumentą <strong>${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
    <modal-confirm
      :title="modalConfirmTitle"
      :text="modalConfirmText"
      :action="modalConfirmAction"
      v-model="showConfirm"
      :item="modalConfirmItem"
      @confirmDuplicate="confirmDuplicate"
      @cancelConfirm="closeConfirm"
    />
    <modal-perdavimas
      v-model="showPerdavimas"
      :item="modalPerdavimasItem"
      @confirmPerdavimas="confirmPerdavimas"
      @cancelPerdavimas="cancelPerdavimas"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import NtrPaslaugosMap from '../ntrpaslaugos/NtrPaslaugosMap'
import ModalDelete from '../modals/ModalDelete'
import ModalConfirm from '../modals/ModalConfirm'
import ModalPerdavimas from '../modals/ModalPerdavimas'
import print from '../../mixins/print'
import userRole from '../../mixins/userRole'
import kurtiPagrindu from './kurtiPagrindu'

export default {
  name: 'PrasymasRengiamiNEP',
  components: {
    ModalDelete,
    ModalConfirm,
    ModalPerdavimas,
  },
  mixins: [userRole, print, kurtiPagrindu],
  props: {
    singleTab: Boolean,
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      showPerdavimas: false,
      modalPerdavimasItem: null,
      prasymai: [],
      searchData: {},
      headers: [
        {
          text: 'Dokumento numeris',
          align: 'start',
          value: 'pra_dokumento_numeris',
        },
        {
          text: 'Prašymo rūšis',
          align: 'start',
          value: 'pra_tipas_pavadinimas',
        },
        {
          text: 'Duomenų teikėjas',
          align: 'start',
          value: 'teikejas',
        },
        {
          text: 'Asmenys',
          align: 'start',
          sortable: false,
          value: 'salys',
        },
        {
          text: 'Būsena',
          align: 'start',
          value: 'pra_busena_pavadinimas',
        },
        {
          text: 'Paskutinis pakeitimas',
          align: 'start',
          value: 'atnaujinimo_data',
        },
        {
          text: 'Paskutinis veiksmus atlikęs asmuo',
          align: 'start',
          value: 'atnaujino',
        },
        {
          text: 'Numatoma pašalinimo data',
          align: 'start',
          value: 'numatoma_pasalinimo_data',
        },
        {
          text: 'Veiksmai',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
      itemsPerPageOptions: [10, 50, 100, -1],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
      lockInterval: null,
      lockTimeout: 10000,
      salinimoLaikas: 30,
    }
  },
  computed: {
    ...mapGetters(['listInfo']),

    filterItemList() {
      return this.prasymai.map(prasymas => {
        // prasymas.canDuplicate = prasymas.galima_kurti_pagrindu
        // prasymas.canTransfer =
        //   this.roleOr([
        //     'DT_notaras',
        //     'DT_notaro_padejejas',
        //     'DT_notaro_atstovas',
        //   ]) &&
        //   (prasymas.pranesimo_busena === 'rengiamas' ||
        //     prasymas.pranesimo_busena === 'grazintas')
        const maxSalis = 5
        prasymas.salysCut = false
        if (prasymas.salys.length > maxSalis) {
          prasymas.salys = prasymas.salys.slice(0, maxSalis)
          prasymas.salysCut = true
        }

        if (prasymas.obj_uzrakinta) {
          prasymas.canLock = true
          prasymas.lockMsg = prasymas.pra_uzrakines_asmuo
          prasymas.canTransfer = false
        } else {
          prasymas.canEdit = true
          prasymas.canDelete = prasymas.pra_busena !== 'grazintas'
        }

        if (prasymas.pra_pasirasymas_vadovas) {
          if (this.roleDT && prasymas.pra_busena_tolimesne === 'perduotas') {
            prasymas.showSign = true
          }
          if (
            prasymas.pra_busena === 'rengiamas' &&
            !this.roleOr(['DT_notaras', 'DT_notaro_atstovas']) &&
            !prasymas.obj_uzrakinta
          ) {
            prasymas.canView = true
            prasymas.canEdit = false
            prasymas.canDelete = false
            prasymas.canTransfer = false
          }
        }

        return prasymas
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
    isLocked() {
      return this.prasymai.filter(item => item.obj_uzrakinta).length > 0
    },
    showTitle() {
      return !this.singleTab
    },
  },
  beforeDestroy() {
    this.stopLoading()
  },
  created() {
    this.pageloading = true
    this.loading = true
    this.getData()
  },
  methods: {
    getData() {
      this.$axios
        .post(`ntrpaslaugos/rengiami`)
        .then(res => {
          this.prasymai = res.data.prasymai
          this.pagination.total = this.prasymai.length
          this.salinimoLaikas = res.data.salinimo_laikas

          if (this.$route.params.toList) {
            this.pagination = this.listInfo.pagination
            this.search = this.listInfo.search
            this.$route.params.toList = false
          }

          this.checkLoading()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    checkLoading() {
      if (this.isLocked) {
        if (!this.lockInterval) {
          this.lockInterval = setInterval(() => {
            this.getData()
          }, this.lockTimeout)
        }
      } else {
        this.stopLoading()
      }
    },
    stopLoading() {
      clearInterval(this.lockInterval)
    },
    editItem(item) {
      const prasymasID = item.pra_id
      this.$store.dispatch('prasymasID', prasymasID)
      this.$store.dispatch('prasymasTipas', item.pra_tipas)

      const listInfo = {
        pra_id: item.pra_id,
        routeName: 'rengiamiDokumentaiPrasymas',
        pagination: this.pagination,
        search: this.search,
      }
      this.$store.dispatch('listInfo', listInfo).then(
        this.$router.push({
          name: 'regPrasymasDuomenys',
          params: {
            prasymasID: prasymasID,
          },
        })
      )
    },
    deleteItem(item) {
      this.modalDeleteVardas = item.pra_dokumento_numeris ?? ''
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`ntrpaslaugos/prasymas/${item.pra_id}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    transferItem(item) {
      this.modalPerdavimasItem = item
      this.showPerdavimas = true
    },
    confirmPerdavimas(data) {
      this.$axios
        .post(`perdavimas/perduoti`, data)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.showPerdavimas = false
        })
    },
    cancelPerdavimas() {
      this.showPerdavimas = false
    },
    rowClass(item) {
      if (item.pasalinimo_status === 'warning') {
        return `zurnalas-warning`
      }
      if (item.pasalinimo_status === 'outdate') {
        return `zurnalas-outdate`
      }
      if (item.pasalinimo_status === 'repost') {
        return `zurnalas-repost`
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
</style>
